import { forwardRef } from "react";
import { bool, node } from "prop-types";
import Quill from "quill";
import { Button } from "@components";
import { Divider } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Header1, Header2, Header3 } from "@assets";
import {
  Code,
  FormatBold,
  FormatItalic, FormatListBulleted,
  FormatListNumbered,
  FormatQuote,
  FormatUnderlined,
  Link,
  StrikethroughS,
} from "@material-ui/icons";
import useStyle from "./QuillToolbar.style";
import classnames from "classnames";

export const QuillToolbar = forwardRef(({
  children,
  visible,
  float,
  hide
}, ref) => {
  
  const classes = useStyle();
  
  return (
    <Grid
      ref={ref}
      item container
      alignItems="center"
      className={classnames(
        classes.root,
        float ? "w-max" : "w-full",
        !visible && "hidden",
        float && "m-0",
        hide && "hidden",
      )}
    >
      {children}
      {Boolean(children) && (
        <Divider
          orientation="vertical"
          className={classes.divider}
        />
      )}
      {
        toolbarButtons.map((s, i) => {
          if(s === "|")
            return <Divider
              key={s+i}
              orientation="vertical"
              className={classes.divider}
            />
          
          const Icon = s[1];
          
          return (
            <Button
              key={s[0]+i}
              className={classnames(classes.button, `ql-${s[0]} p-0-5 text-lg`)}
              size="small"
              value={s[2]}
            >
              <Icon />
            </Button>
          )
        })
      }
    </Grid>
  )
});

QuillToolbar.propTypes = {
  children: node,
  visible: bool,
  float: bool,
  hide: bool,
}

const toolbarButtons = [
  ["bold", FormatBold],
  ["italic", FormatItalic],
  ["underline", FormatUnderlined],
  ["strike", StrikethroughS],
  ["code", Code],
  ["link", Link],
  "|",
  ["header", Header1, "1"],
  ["header", Header2, "2"],
  ["header", Header3, "3"],
  "|",
  ["list", FormatListNumbered,  "ordered"],
  ["list", FormatListBulleted, "bullet"],
  "|",
  ["blockquote", FormatQuote],
  ["code-block", Code],
]

const icons = Quill.import("ui/icons");
icons.bold = null;
icons.italic = null;
icons.underline = null;
icons.code = null;
icons["code-block"] = null;
icons.blockquote = null;
icons.strike = null;
icons.underline = null;
icons.link = null;
icons.header = {
  1: null,
  2: null,
};
icons.list = {
  ordered: null,
  bullet: null,
};